module.exports = __webpack_public_path__ + "img/child-profile-empty.a813a942.png";